// extracted by mini-css-extract-plugin
export default {"projectMedia":"ProjectMedia_projectMedia__Qa5tT"};